import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const LoadboardLabel = ({ text, children, className = "" }) => {
    return <div className={cn("text-cm-p-text-primary text-xs/[19px]", className)}>{text ? <TranslatedText text={text} /> : children}</div>;
};
